<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-calendar"></i> 报表管理
        </el-breadcrumb-item>
        <el-breadcrumb-item>退货报表</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form ref="searchform" :model="searchform" label-width="80px">
          <el-row>
            <el-col :span="6">
              <el-form-item label="客户编码" prop="dealer_code" >
                <el-input v-model="searchform.dealer_code" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="销售退货单" prop="rejected_orderno" label-width="110px">
                <el-input v-model="searchform.rejected_orderno" style="width:100%" clearable></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="退货类型" prop="rejected_order_type">
                 <el-select v-model="searchform.rejected_order_type" style="width:90%" placeholder="请选择退货类型">
                  <el-option
                    v-for="item in rejected_order_type"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="扫码日期" prop="datelist" @change="ceshi()">
                   <el-date-picker
                           style="width:100%"
                           v-model="searchform.datelist"
                           type="daterange"
                            value-format="timestamp"
                           range-separator="-"
                           start-placeholder="开始日期"
                           end-placeholder="结束日期">
                   </el-date-picker>
              </el-form-item>
            </el-col>     
          </el-row>
                      <el-row>
            <el-col :span="8" :offset="1"> 
               <el-button @click="resetForm('searchform')">重置</el-button>
              <el-button type="primary" icon="el-icon-search" @click="search" v-permission="['phoenix_select']">搜索</el-button>
               <el-button
                :loading="downloadLoading"
                type="primary"
                icon="document"
                @click="handleDownload"
                v-permission="['phoenix_export']"
              >导出Excel</el-button>
            </el-col>
            </el-row> 
        </el-form>
      </div>
<br>
      <el-row type="flex" class="row-bg">
        <el-col :span="24" class="border">
          <h4>退货报表</h4>
          <el-divider></el-divider>
          <el-table
            border
            v-loading="listLoading"
            element-loading-text="拼命加载中"
            :data="tableData"
            style="width:100%;"
            id="parent"
          >
            <el-table-column prop="rejected_orderno" label="销售退货单号" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product_code" label="产品编码" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="product_name" label="产品名称" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealer_code" label="客户编码" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="dealer_name" label="客户名称" min-width="180" show-overflow-tooltip></el-table-column>
            <el-table-column prop="batch_no" label="批次" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="specs" label="箱规" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="level2qty" label="箱码数" min-width="80" show-overflow-tooltip></el-table-column>
            <el-table-column prop="level1qty" label="盒码数" min-width="80" show-overflow-tooltip ></el-table-column>
            <el-table-column prop="countQty" label="总数量" min-width="80" show-overflow-tooltip ></el-table-column> 
            <el-table-column prop="rejected_order_type" label="退货类型" min-width="120" show-overflow-tooltip fixed="right"></el-table-column>  
            <el-table-column prop="rejected_time" label="扫码退货日期" min-width="140" show-overflow-tooltip fixed="right"></el-table-column>
          </el-table>
          <br />
          <el-pagination
            background
            @current-change="currentchange"
            @size-change="pagesize"
            :current-page.sync="currentPage"
            :page-sizes="[10,20,30,50]"
            layout="total,prev, pager, next,jumper,sizes"
            :total="total_count"
          ></el-pagination>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import { findRejected } from "@/api/report";
export default {
  mounted() {
    //请求部门列表数据并且便利到表格
    this.Tabledata();
  },
  data() {
    return {
      //基础数据
      listLoading: false,
      depart_uuid: [],
      tableData: [],
      //导出表格变量
      tableDataDownload:[],
      downloadLoading: false,
      filename: "",
      autoWidth: true,
      bookType: "xlsx",
      //分页数据
      pagesizes: "",
      total_count: 1,
      currentPage: 1,
      //搜索表单数据
     qrcode_status:[
       {
         value:3,
         label:"已下载"
       },
       {
         value:4,
         label:"未下载"
       }
     ],
     rejected_order_type:[
       {
         value:0,
         label:"拒收退货"
       },
       {
         value:2,
         label:"销售退货"
       }
     ],
      searchform: {
        rejected_orderno:null,
        rejected_order_type:null,
        datelist:[],
        srejectedTime:null,
        erejectedTime:null,
        dealer_code: null,
        currPage:1,
        pageSize:10
      }
    };
  },
  methods: {
    //请求表格数据
    Tabledata(obj) {
      this.listLoading = true;
      findRejected(obj).then(response => {
        this.tableData = response.data.list;
        this.packdate(this.tableData);
        this.total_count = response.data.totalCount;
        this.currentPage = response.data.page;
        this.listLoading = false;
        console.log(this.tableData)
      });
    },
    // 拼装数据
    packdate(obj){
       for (let i = 0; i < obj.length; i++) {
         obj[i].rejected_time = this.$parseTime(obj[i].rejected_time)
         switch (obj[i].qrcode_status) {
          case 3:obj[i].qrcode_status = "已下载"           
            break;
          default:obj[i].qrcode_status= "未下载"
            break;
        };
        switch (obj[i].rejected_order_type) {
             case 0:obj[i].rejected_order_type = "拒收退货"           
            break;
             case 2:obj[i].rejected_order_type = "销售退货"           
            break;
          default:
            break;
        } 
        }
    },
    ceshi(){
      console.log(this.searchform.datelist)
    },
    //搜索事件
    search() {
        this.Tabledata({
          rejected_orderno:this.searchform.rejected_orderno,
        rejected_order_type:this.searchform.rejected_order_type,
        dealer_code:this.searchform.dealer_code,
        srejectedTime:this.searchform.datelist==null ? null:this.searchform.datelist[0],
        erejectedTime:this.searchform.datelist==null ? null:this.searchform.datelist[1],
        pageSize:this.searchform.pageSize
        });
    },
    //重置按钮
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    //分页跳转事件
    currentchange(currPage) {
      this.searchform.currPage = currPage
       this.Tabledata({
        rejected_orderno:this.searchform.rejected_orderno, 
        rejected_order_type:this.searchform.rejected_order_type,
        dealer_code:this.searchform.dealer_code,
        srejectedTime:this.searchform.datelist==null ? null:this.searchform.datelist[0],
        erejectedTime:this.searchform.datelist==null ? null:this.searchform.datelist[1],
        pageSize:this.searchform.pageSize,
        currPage:this.searchform.currPage,
        });
      console.log(currPage)
    },
    //分页每页显示条数事件
    pagesize(pageSize) {
      this.searchform.pageSize = pageSize
      this.search()
    },
            //导出表格事件
    handleDownload() {
      this.downloadLoading = true;
      const obj = {
        currPage:1,
        pageSize:this.total_count,
        rejected_orderno:this.searchform.rejected_orderno,
        rejected_order_type:this.searchform.rejected_order_type,
        dealer_code:this.searchform.dealer_code,
        srejectedTime:this.searchform.datelist==null ? null:this.searchform.datelist[0],
        erejectedTime:this.searchform.datelist==null ? null:this.searchform.datelist[1],
      };
     findRejected(obj).then(response => {
        this.tableDataDownload = response.data.list;
        this.packdate(this.tableDataDownload);
      import("@/vendor/Export2Excel").then(excel => {
        const tHeader = ["销售退货单号", "产品编码", "产品名称", "客户编码", "客户名称","批次","箱规", "箱码数", "盒码数","总数量","退货类型","扫码退货日期"];
        const filterVal = [
          "rejected_orderno",
          "product_code",
          "product_name",
          "dealer_code",
          "dealer_name",
           "batch_no",
          "specs",
          "level2qty",
          "level1qty",
          "countQty",
          "rejected_order_type",
          "rejected_time",
        ];
        const list = this.tableDataDownload;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename,
          autoWidth: this.autoWidth,
          bookType: this.bookType
        });
        this.downloadLoading = false;
      });
            }); // hear
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          if (j === "timestamp") {
            return parseTime(v[j]);
          } else {
            return v[j];
          }
        })
      );
    },
    //跳转页面
    tiaozhuan() {
      this.$router.push({
        path: "/staffedit"
      });
    }
  }
};
</script>
<style scoped>

</style>